import { Divider } from "@mui/material";
import type { ChangeEvent } from "react";
import { defineMessages, useIntl } from "react-intl";

import { Checkbox } from "@/components/Checkbox/Checkbox";
import { HOTEL_CLASSES } from "@/features/hotels/utils/constants";

const starLabels = defineMessages<number>({
  0: { defaultMessage: "Unrated", description: "hotels.filters.stars.0" },
  1: { defaultMessage: "1 star", description: "hotels.filters.stars.1" },
  2: { defaultMessage: "2 stars", description: "hotels.filters.stars.2" },
  3: { defaultMessage: "3 stars", description: "hotels.filters.stars.3" },
  4: { defaultMessage: "4 stars", description: "hotels.filters.stars.4" },
  5: { defaultMessage: "5 stars", description: "hotels.filters.stars.5" },
});

type Props = {
  selectedClasses?: number[];
  userManuallySelectedAllClasses: boolean;
  onChange: (
    event: ChangeEvent<HTMLInputElement>,
    checked: boolean,
    option: number,
  ) => void;
};

export const HotelClassFilter = ({
  selectedClasses = [],
  userManuallySelectedAllClasses,
  onChange,
}: Props) => {
  const intl = useIntl();

  const areAllClassesSelected = selectedClasses.length === HOTEL_CLASSES.length;

  return (
    <ul>
      {HOTEL_CLASSES.map((option) => (
        <li key={option}>
          <label className="flex w-full items-center justify-between py-2">
            <span className="font-medium text-text-primary">
              {intl.formatMessage(starLabels[option] ?? starLabels[0])}
            </span>
            <Checkbox
              checked={
                selectedClasses?.includes(option) &&
                (userManuallySelectedAllClasses || !areAllClassesSelected)
              }
              onChange={(e) => onChange(e, e.target.checked, option)}
              density="compact"
            />
          </label>
          <Divider />
        </li>
      ))}
    </ul>
  );
};
